import { FC } from 'react'
import cn from 'classnames'

export interface SpinnerProps {
  /** Size and ring colours, e.g. `size-[18px] border-2 border-white/40 border-t-white`. Not defaulted:
   * two `size-*` utilities on one element are resolved by stylesheet order, not by argument order. */
  className?: string
}

/**
 * Ring spinner for a control that keeps its content while a request is in flight — a button that stays
 * a button, a stepper that stays a stepper. Decorative on purpose: the control around it carries
 * `aria-busy`, so there is nothing to announce twice.
 *
 * Not to be confused with `Loader`, which stands in place of content that is not there yet: that one
 * declares `role="status"` and its own size, and is the wrong shape inside a control.
 */
export const Spinner: FC<SpinnerProps> = ({ className }) => (
  <span aria-hidden className={cn('shrink-0 animate-spin rounded-full motion-reduce:animate-none', className)} />
)
